/** Remount key for the product scroll controller — one per pathname. */
export const getSpartanProductScrollPathScope = (pathname: string): string =>
  pathname;
